export default __webpack_public_path__ + "static/damixa--mobile@1x-1ad48c73040c778f8041e8d06163ab31.webp";